import { SimpleDateInput } from "cerulean";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

// ideally this interface will look more like an HTML input
// but we need to reckon with Cleave/cerulean.
interface DateInputProps<T extends FieldValues> {
  control: Control<T, unknown>;
  name: Path<T>;
  label: string;
  disabled?: boolean;
}

function DateInput<T extends FieldValues>(props: DateInputProps<T>) {
  const { control, name, label, ...inputProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, onBlur, value, ref }, fieldState: { error } }) => {
        const onBlurHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value.length < 10) {
            onChange(e.target.value);
          }
          onBlur();
        };
        return (
          <SimpleDateInput
            label={label}
            value={value || ""}
            onChange={onChange}
            onBlur={onBlurHandler}
            error={error?.message}
            ref={ref}
            {...inputProps}
          />
        );
      }}
    />
  );
}

export { DateInput };
